import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import {
  ADDRESSES_SEARCH,
  ADDRESSES_SEARCH_FULFILLED,
  ADDRESSES_SEARCH_REJECTED,
  CLEAR_ADDRESSES_SEARCH,
} from './actionTypes';
import { AddressesSearchActionType, AddressesSearchState } from './types';

const initialState: AddressesSearchState = RemoteRecordData.getDefault();

const reducer = (
  state: AddressesSearchState = initialState,
  action: AddressesSearchActionType,
): AddressesSearchState => {
  switch (action.type) {
    case ADDRESSES_SEARCH:
      return RemoteRecordData.init();

    case ADDRESSES_SEARCH_FULFILLED:
      return RemoteRecordData.fulfill(action.payload.data);

    case ADDRESSES_SEARCH_REJECTED:
      return RemoteRecordData.reject(action.payload.error);

    case CLEAR_ADDRESSES_SEARCH:
      return initialState;

    default:
      return state;
  }
};

export {
  reducer,
};
